<mat-toolbar color="primary" class="toolbar">
    <app-back-button [route]="['/home', 'perfil']" color="secondary"></app-back-button>
    <div>{{ "ACCOUNT.TITLE" | translate }}</div>
</mat-toolbar>

<div class="form-container">
    <form [formGroup]="formGroup">
        <mat-card class="account-container">
            <mat-card-header>
                <mat-card-title>
                    {{ "ACCOUNT.CARDS.PUBLIC.TITLE" | translate }}
                </mat-card-title>
            </mat-card-header>

            <mat-card-content class="account-content">
                <button
                    [id]="'button_profile-account_EditarSalvar'"
                    mat-mini-fab
                    color="primary"
                    (click)="toggleEdition()"
                    class="edition-button"
                >
                    <mat-icon aria-label="label">{{ editMode ? "save" : "create" }}</mat-icon>
                </button>

                <mat-form-field>
                    <mat-label>
                        {{ "ACCOUNT.CARDS.PUBLIC.INPUTS.NAME" | translate }}
                    </mat-label>
                    <input
                        [id]="'input_profile-account_Name'"
                        matInput
                        #nome
                        placeholder="{{ 'ACCOUNT.CARDS.PUBLIC.INPUTS.NAME_PLACEHOLDER' | translate }}"
                        maxlength="50"
                        formControlName="nome"
                        required
                    />
                    <mat-hint align="end"> {{ nome.value.length }} / 50 </mat-hint>
                    <mat-error>
                        {{ "ACCOUNT.CARDS.PUBLIC.INPUTS.NOME_ERROR" | translate }}
                    </mat-error>
                </mat-form-field>

                <mat-form-field>
                    <mat-label>
                        {{ "ACCOUNT.CARDS.PUBLIC.INPUTS.LAST_NAME" | translate }}
                    </mat-label>
                    <input
                        [id]="'input_profile-account_LastName'"
                        matInput
                        #nome
                        placeholder="{{ 'ACCOUNT.CARDS.PUBLIC.INPUTS.LAST_NAME_PLACEHOLDER' | translate }}"
                        maxlength="50"
                        formControlName="sobrenome"
                        required
                    />
                    <mat-hint align="end"> {{ nome.value.length }} / 50 </mat-hint>
                    <mat-error>
                        {{ "ACCOUNT.CARDS.PUBLIC.INPUTS.NOME_ERROR" | translate }}
                    </mat-error>
                </mat-form-field>

                <mat-form-field>
                    <mat-label>
                        {{ "ACCOUNT.CARDS.PUBLIC.INPUTS.POSITION" | translate }}
                    </mat-label>
                    <input
                        [id]="'input_profile-account_Cargo'"
                        matInput
                        #headline
                        placeholder="{{ 'ACCOUNT.CARDS.PUBLIC.INPUTS.POSITION_PLACEHOLDER' | translate }}"
                        maxlength="50"
                        formControlName="headline"
                    />
                    <mat-hint align="end"> {{ headline.value.length }} / 50 </mat-hint>
                    <mat-error>
                        {{ "ACCOUNT.CARDS.PUBLIC.INPUTS.POSITION_ERROR" | translate }}
                    </mat-error>
                </mat-form-field>

                <div
                    fxLayout="row"
                    fxLayout.xs="column"
                    fxLayoutAlign="start center"
                    fxLayoutGap="8px"
                    *ngIf="userCustomFields | async"
                >
                    <app-user-custom-fields
                        #appUserCustomFields
                        [fields]="userCustomFields | async"
                        [user]="user"
                        [editMode]="editMode"
                    ></app-user-custom-fields>
                </div>

                <angular-editor
                    #apresentacao
                    [placeholder]="'ACCOUNT.CARDS.PUBLIC.INPUTS.PRESENTATION_PLACEHOLDER' | translate"
                    [config]="editorConfig"
                    formControlName="apresentacao"
                ></angular-editor>
            </mat-card-content>
        </mat-card>

        <mat-card class="social-network-container">
            <mat-card-header>
                <mat-card-title> Links </mat-card-title>
            </mat-card-header>
            <mat-card-content class="social-network-content">
                <mat-form-field>
                    <input
                        [id]="'input_profile-account_Linkedn'"
                        matInput
                        #urlLinkedin
                        maxlength="100"
                        formControlName="urlLinkedin"
                        maxlength="100"
                        placeholder="LinkedIn"
                    />
                    <mat-icon svgIcon="linkedin" style="color: #0077b5" matSuffix></mat-icon>
                    <mat-hint align="end"> {{ urlLinkedin.value.length }} / 100 </mat-hint>
                </mat-form-field>

                <mat-form-field>
                    <input
                        [id]="'input_profile-account_Stackoverflow'"
                        matInput
                        #urlStackOverflow
                        maxlength="100"
                        formControlName="urlStackOverflow"
                        maxlength="100"
                        placeholder="Stack Overflow"
                    />
                    <mat-icon svgIcon="stack-overflow" style="color: #ffac44" matSuffix></mat-icon>
                    <mat-hint align="end"> {{ urlStackOverflow.value.length }} / 100 </mat-hint>
                </mat-form-field>

                <mat-form-field>
                    <input
                        [id]="'input_profile-account_Facebook'"
                        matInput
                        #urlFacebook
                        maxlength="100"
                        formControlName="urlFacebook"
                        maxlength="100"
                        placeholder="Facebook"
                    />
                    <mat-icon svgIcon="facebook" style="color: #3b5998" matSuffix></mat-icon>
                    <mat-hint align="end"> {{ urlFacebook.value.length }} / 100 </mat-hint>
                </mat-form-field>

                <mat-form-field>
                    <input
                        [id]="'input_profile-account_Twitter'"
                        matInput
                        #urlTwitter
                        maxlength="100"
                        formControlName="urlTwitter"
                        maxlength="100"
                        placeholder="Twitter"
                    />
                    <mat-icon svgIcon="twitter" style="color: #55acee" matSuffix></mat-icon>
                    <mat-hint align="end"> {{ urlTwitter.value.length }} / 100 </mat-hint>
                </mat-form-field>
            </mat-card-content>
        </mat-card>
    </form>
</div>
